import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getDailyActiveUsersCount,
  getMonthlyActiveUsers,
  getWeeklyActiveUsers,
} from './thunks';
import { AnalysisState } from './types';

export const name = 'analysis';

const initialState: AnalysisState = {
  weeklyActiveReadersData: [],
  monthlyActiveReadersData: [],
  dailyActiveUsersCount: [],
  weeklyActiveReadersStatus: 'idle',
  monthlyActiveReadersStatus: 'idle',
  dailyActiveUsersCountStatus: 'idle',
};
export const getDailyActiveUsersCountAsync = createAsyncThunk(
  name + '/getDailyActiveUsersCount',
  getDailyActiveUsersCount
);

export const getMonthlyActiveUsersAsync = createAsyncThunk(
  name + '/getMonthlyActiveUsers',
  getMonthlyActiveUsers
);

export const getWeeklyActiveUsersAsync = createAsyncThunk(
  name + '/getWeeklyActiveUsers',
  getWeeklyActiveUsers
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDailyActiveUsersCountAsync.pending, (state) => {
        state.dailyActiveUsersCountStatus = 'loading';
      })
      .addCase(getDailyActiveUsersCountAsync.fulfilled, (state, action) => {
        state.dailyActiveUsersCountStatus = 'idle';
        state.dailyActiveUsersCount = action.payload;
      })
      .addCase(getDailyActiveUsersCountAsync.rejected, (state, action) => {
        state.dailyActiveUsersCountStatus = 'failed';
      })
      .addCase(getMonthlyActiveUsersAsync.pending, (state) => {
        state.monthlyActiveReadersStatus = 'loading';
      })
      .addCase(getMonthlyActiveUsersAsync.fulfilled, (state, action) => {
        state.monthlyActiveReadersStatus = 'idle';
        state.monthlyActiveReadersData = action.payload;
      })
      .addCase(getMonthlyActiveUsersAsync.rejected, (state, action) => {
        state.monthlyActiveReadersStatus = 'failed';
      })
      .addCase(getWeeklyActiveUsersAsync.pending, (state) => {
        state.weeklyActiveReadersStatus = 'loading';
      })
      .addCase(getWeeklyActiveUsersAsync.fulfilled, (state, action) => {
        state.weeklyActiveReadersStatus = 'idle';
        state.weeklyActiveReadersData = action.payload;
      })
      .addCase(getWeeklyActiveUsersAsync.rejected, (state, action) => {
        state.weeklyActiveReadersStatus = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
